const SectionTitle = ({ icon, title, note }) => (
    <div className="d-flex align-items-start mb-3">
      <div
        className="d-flex align-items-center justify-content-center mr-3"
        style={{
          width: 40,
          height: 40,
          borderRadius: 12,
          background: "rgba(0,123,255,0.10)",
          border: "1px solid rgba(0,123,255,0.18)",
        }}
      >
        <i className={`fa ${icon} text-primary`} />
      </div>
      <div>
        <div className="font-weight-semibold">{title}</div>
        {note ? (
          <div className="text-muted" style={{ fontSize: 12, marginTop: 2 }}>
            {note}
          </div>
        ) : null}
      </div>
    </div>
  );

export default SectionTitle;